import moment from "moment";
import api from "../api/index";
import { buildParamQuery } from "../helpers";
// import {round_to_precision} from '../helpers'
const getLastDateOfChosenMonth = (chosen_month) => {
  const start_date = new Date(chosen_month + "-01");
  return moment(start_date).endOf("month");
};

const handelElectricWaterPrice = (arr) => {
  let sorted_arr = arr.sort((a, b) => {
    let unix_a = moment(a.date_check).unix();
    let unix_b = moment(b.date_check).unix();
    if (unix_a < unix_b) return 1;
    if (unix_a > unix_b) return -1;
    return 0;
  });
  let end = sorted_arr[0] ? sorted_arr[0].count : 0;
  let start = sorted_arr[1] ? sorted_arr[1].count : 0;
  if (sorted_arr[0] && sorted_arr[0].check_in_id && start == 0) {
    start = end;
  }
  return { data: sorted_arr, start, end };
};

const handleDateCount = ({
  date_start,
  chosen_month,
  date_end,
  is_room_date_count,
  date_schedule_end,
  is_check_out,
}) => {
  // Parse provided dates
  const computed_date_end = date_end ? new Date(date_end) : new Date(); // Default to today if no end date
  const computed_date_schedule_end = date_schedule_end
    ? new Date(date_schedule_end)
    : "";
  const computed_date_start = new Date(date_start.substr(0, 10));

  // Get the first and last dates of the chosen month
  const first_date_of_chosen_month = new Date(chosen_month + "-01");
  const last_date_of_chosen_month = new Date(
    getLastDateOfChosenMonth(chosen_month)
  );

  // 💡 If the stay ends before the month or starts after it → 0 days in the month
  if (
    computed_date_end < first_date_of_chosen_month ||
    computed_date_start > last_date_of_chosen_month
  )
    return 0;

  // 🧾 Special handling if there's a schedule_end and the end date goes beyond the selected month
  if (
    computed_date_schedule_end &&
    computed_date_end > moment(first_date_of_chosen_month).endOf("month")
  ) {
    const days_of_current_month =
      computed_date_start > first_date_of_chosen_month
        ? computed_date_start.getDate()
        : 0;

    // Return estimated total days: remaining days + schedule_end day
    return 30 - days_of_current_month + computed_date_schedule_end.getDate();
  }

  // Clamp end date to not go past the month
  const new_date_end =
    last_date_of_chosen_month < computed_date_end
      ? last_date_of_chosen_month
      : computed_date_end;

  // Clamp start date to not be before the month
  const new_date_start =
    first_date_of_chosen_month > computed_date_start
      ? first_date_of_chosen_month
      : computed_date_start;

  // 🎯 Full month occupancy → return 30
  if (
    moment(new_date_start).diff(moment(first_date_of_chosen_month), "days") ==
    0 &&
    moment(new_date_end).diff(moment(last_date_of_chosen_month), "days") == 0
  )
    return 30;

  // Bắt đầu và kết thúc cùng 1 ngày
  if (new_date_start.toDateString() === new_date_end.toDateString()) return 1;

  // À, nếu kết thúc vào này 1, mà ngày bắt đầu không phải ngày 1 thì xem như có dùng/ở 1 ngày
  // Không thì kết thúc vào 1 xem như là không có xài
  if (new_date_end.getDate() === new_date_start.getDate()) {
    if (
      new_date_end.getDate() === 1 &&
      computed_date_start.toDateString() !==
      first_date_of_chosen_month.toDateString()
    ) {
      return 1;
    } else return 0;
  }

  // Calculate difference in days
  // - Chị Trân: Tính một tháng 30 ngày (bất kể tháng đó có 31 ngày/ 30 ngày/ 28 ngày)
  // - Chị Trân: Phòng ở full tháng 30 ngày
  // - Chị Trân: Phòng mới vào: 30 ngày - ngày vào + tính luôn ngày vào
  // - Son NT: vậy tháng 2, vào ngày 15 cũng tính là ở 16 ngày phải ko chị?
  // - Chị Trân: Chính xác

  // Nếu tới cuối tháng thì tính từ 30 - ngày bắt đầu + 1
  if (
    moment(new_date_end).diff(moment(last_date_of_chosen_month), "days") === 0
  ) {
    return 30 - new_date_start.getDate() + 1;
  } else {
    return new_date_end.getDate() - new_date_start.getDate() + 1;
  }
};

const getInternetPriceHistoryForDevices = async (internetDevices, allInternetUsers = null, allPriceHistory = null) => {
  const priceHistoryMap = {};

  let internetUsersList = allInternetUsers;
  if (!internetUsersList) {
    const internetResponse = await api.getListInternet();
    if (internetResponse.status !== 200 || !internetResponse.data || !internetResponse.data.internet) {
      return priceHistoryMap;
    }
    internetUsersList = internetResponse.data.internet;
  }

  const deviceToInternetUserMap = {};

  for (const device of internetDevices) {
    if (device.type === "INTERNET" && device.room_id && device.building && device.name) {
      const internetUser = internetUsersList.find(
        user => user.room_id === device.room_id &&
          user.building === device.building &&
          user.is_valid
      );

      if (internetUser && internetUser._id) {
        deviceToInternetUserMap[device._id] = internetUser._id;
      }
    }
  }

  // Nếu có allPriceHistory thì dùng nó, không cần gọi API
  if (allPriceHistory) {
    for (const device of internetDevices) {
      if (deviceToInternetUserMap[device._id]) {
        const userId = deviceToInternetUserMap[device._id];
        const history = allPriceHistory[userId];
        if (history) {
          priceHistoryMap[device._id] = history;
        }
      }
    }
    return priceHistoryMap;
  }

  // Nếu không có allPriceHistory thì gọi API như cũ (fallback)
  const internetUserIds = [];
  for (const device of internetDevices) {
    if (deviceToInternetUserMap[device._id]) {
      const userId = deviceToInternetUserMap[device._id];
      if (!internetUserIds.includes(userId)) {
        internetUserIds.push(userId);
      }
    }
  }

  const historyPromises = internetUserIds.map(async (userId) => {
    try {
      const historyResponse = await api.getInternetPriceHistory(userId);
      if (historyResponse.status === 200 && historyResponse.data && historyResponse.data.data) {
        return { userId, history: historyResponse.data.data };
      }
      return { userId, history: [] };
    } catch (error) {
      console.error(`Lỗi lấy lịch sử giá cho user ${userId}:`, error);
      return { userId, history: [] };
    }
  });

  const historyResults = await Promise.all(historyPromises);

  // Map kết quả về device
  for (const device of internetDevices) {
    if (deviceToInternetUserMap[device._id]) {
      const userId = deviceToInternetUserMap[device._id];
      const historyResult = historyResults.find(result => result.userId === userId);
      if (historyResult) {
        priceHistoryMap[device._id] = historyResult.history;
      }
    }
  }

  return priceHistoryMap;
};

const calculateInternetBill = (internetDevices, chosen_month, date_end, internetPriceHistory = {}, roomDateStart = null, roomDateEnd = null) => {
  // Tính số ngày thực tế của tháng (31 cho tháng 1, 30 cho tháng 4, v.v.)
  const [year, month] = chosen_month.split('-').map(Number);
  const actualLastDayOfMonth = new Date(year, month, 0).getDate(); // Số ngày lịch của tháng (28–31)
  const billingLastDayOfMonth = Math.min(actualLastDayOfMonth, 30); // Nghiệp vụ: tính internet tối đa đến ngày 30
  const clampDay31To30 = (d) => {
    const x = new Date(d);
    if (Number.isNaN(x.getTime())) return x;
    if (x.getDate() === 31) x.setDate(30);
    return x;
  };

  const endDate = new Date(year, month - 1, actualLastDayOfMonth, 23, 59, 59); // Ngày cuối thực tế của tháng
  
  // Kiểm tra nếu phòng không ở từ đầu tháng (check trong tháng chosen_month)
  const monthStart = new Date(year, month - 1, 1);
  monthStart.setHours(0, 0, 0, 0);
  const monthEnd = new Date(year, month - 1, actualLastDayOfMonth, 23, 59, 59); // Ngày cuối thực tế của tháng
  
  // Check xem có device valid nào bắt đầu trong tháng chosen_month không
  const validDevicesInMonth = internetDevices.filter(device => {
    if (!device.is_valid) return false;
    const deviceStart = clampDay31To30(new Date(device.date_start));
    deviceStart.setHours(0, 0, 0, 0);
    return deviceStart >= monthStart && deviceStart <= monthEnd;
  });
  
  // Kiểm tra nếu phòng không ở từ đầu tháng (dựa vào roomDateStart từ bảng internet)
  let isRoomNotFromStartOfMonth = false;
  
  if (roomDateStart) {
    const roomStart = clampDay31To30(new Date(roomDateStart));
    roomStart.setHours(0, 0, 0, 0);
    // Check xem roomDateStart có trong tháng chosen_month không
    if (roomStart >= monthStart && roomStart <= monthEnd) {
      isRoomNotFromStartOfMonth = roomStart.getDate() !== 1;
    }
  }
  // Nếu phòng không ở từ đầu tháng, lấy TẤT CẢ devices có date_start >= date_start của internet (roomDateStart)
  let selectedDevices = internetDevices;
  let deviceStartDay = null; // Ngày bắt đầu của device được chọn (nếu có)
  
  if (isRoomNotFromStartOfMonth && roomDateStart) {
    const internetDateStart = clampDay31To30(new Date(roomDateStart));
    internetDateStart.setHours(0, 0, 0, 0);
    
    // Lấy TẤT CẢ devices có date_start >= date_start của internet (roomDateStart)
    selectedDevices = validDevicesInMonth.filter(device => {
      const deviceStart = clampDay31To30(new Date(device.date_start));
      deviceStart.setHours(0, 0, 0, 0);
      return deviceStart >= internetDateStart;
    });
    
    // Nếu không có device nào trong validDevicesInMonth, lấy từ tất cả devices
    if (selectedDevices.length === 0) {
      selectedDevices = internetDevices.filter(device => {
        if (!device.is_valid) return false;
        const deviceStart = clampDay31To30(new Date(device.date_start));
        deviceStart.setHours(0, 0, 0, 0);
        return deviceStart >= internetDateStart;
      });
    }
    
    // Lấy date_start nhỏ nhất từ các devices đã chọn để tính deviceStartDay
    if (selectedDevices.length > 0) {
      selectedDevices.sort((a, b) => new Date(a.date_start) - new Date(b.date_start));
      const selectedDeviceStart = clampDay31To30(new Date(selectedDevices[0].date_start));
      selectedDeviceStart.setHours(0, 0, 0, 0);
      
      // Ngày bắt đầu tính internet trong tháng = đúng ngày date_start (theo lịch), không cộng thêm 1
      if (selectedDeviceStart >= monthStart && selectedDeviceStart <= monthEnd) {
        deviceStartDay = selectedDeviceStart.getDate();
      }
    }
  }
  
  // Tính số ngày thực tế phòng ở trong tháng
  // Nếu không có roomDateStart/roomDateEnd, dùng full tháng
  let roomStartDay = 1;
  let roomEndDay = billingLastDayOfMonth;
  let actualRoomDays = billingLastDayOfMonth;
  
  // Nếu đã chọn device từ date_in, tính từ date_start của device đến cuối tháng
  if (deviceStartDay !== null) {
    roomStartDay = deviceStartDay;
    roomEndDay = billingLastDayOfMonth;
    actualRoomDays = roomEndDay - roomStartDay + 1;
  } else if (roomDateStart && roomDateEnd) {
    const roomStart = clampDay31To30(new Date(roomDateStart));
    const roomEnd = clampDay31To30(new Date(roomDateEnd));
    const monthStart = new Date(year, month - 1, 1);
    monthStart.setHours(0, 0, 0, 0);
    const monthEnd = new Date(year, month, 0, 23, 59, 59);
    
    // Clamp room dates vào tháng
    let clampedRoomStart = new Date(roomStart);
    clampedRoomStart.setHours(0, 0, 0, 0);
    if (clampedRoomStart < monthStart) {
      clampedRoomStart = new Date(monthStart);
    }
    
    let clampedRoomEnd = new Date(roomEnd);
    clampedRoomEnd.setHours(23, 59, 59, 999);
    if (clampedRoomEnd > monthEnd) {
      clampedRoomEnd = new Date(monthEnd);
    }
    
    // Kiểm tra xem có overlap với tháng không
    if (clampedRoomStart <= clampedRoomEnd && clampedRoomStart <= monthEnd && clampedRoomEnd >= monthStart) {
      // Tính từ đúng ngày phòng ở trong tháng (sau clamp), không +1
      roomStartDay = clampedRoomStart.getDate();
      roomEndDay = Math.min(clampedRoomEnd.getDate(), billingLastDayOfMonth);
      // Tính số ngày: từ roomStartDay đến roomEndDay (bao gồm cả 2 ngày)
      actualRoomDays = roomEndDay - roomStartDay + 1;
    } else {
      // Phòng không ở trong tháng này
      actualRoomDays = 0;
    }
  } else {
    // Nếu không có roomDateStart/roomDateEnd, dùng full tháng (tối đa 30 ngày tính tiền)
    actualRoomDays = billingLastDayOfMonth;
    roomStartDay = 1;
    roomEndDay = billingLastDayOfMonth;
  }
  
  let totalInternetPriceDays = 0; // Tổng (giá * số ngày) của tất cả internet devices
  
  // Chuẩn bị danh sách devices với thông tin đầy đủ
  const devicesWithDates = [];
  selectedDevices.forEach((device) => {
    const deviceDateEnd = device.is_valid ? date_end : device.date_end;
    let deviceStart = clampDay31To30(new Date(device.date_start));
    let deviceEnd = deviceDateEnd ? clampDay31To30(new Date(deviceDateEnd)) : endDate;
    // Đảm bảo deviceEnd không vượt quá ngày cuối tháng
    if (deviceEnd > endDate) {
      deviceEnd = new Date(endDate);
    }

    device.date_count = handleDateCount({
      date_start: device.date_start,
      chosen_month,
      date_end: deviceDateEnd,
      is_room_date_count: false,
    });
    
    if (device.date_count > 0) {
      // Giá mặc định từ device (sẽ được override bởi history nếu có)
      const defaultDevicePrice = device.customer_price !== null && device.customer_price !== undefined 
        ? device.customer_price 
        : (device.price || 0);
      
      // Lấy price history cho device này
      const deviceHistory = internetPriceHistory[device._id] || [];
      
      devicesWithDates.push({
        device,
        defaultDevicePrice,
        history: deviceHistory,
        start: deviceStart,
        end: deviceEnd,
        date_count: device.date_count
      });
    }
  });
  
  // Hàm helper để lấy giá cho một ngày cụ thể từ history
  const getPriceForDate = (deviceWithDate, targetDate) => {
    const { device, defaultDevicePrice, history } = deviceWithDate;
    
    // Device cũ (is_valid: false) không dùng history, chỉ dùng giá từ device
    if (!device.is_valid) {
      return defaultDevicePrice;
    }
    
    if (!history || history.length === 0) {
      return defaultDevicePrice;
    }
    
    const targetDateOnly = new Date(targetDate);
    targetDateOnly.setHours(0, 0, 0, 0);

    const matchingRecords = history.filter(h => {
      const startDate = h.start_effective_date ? new Date(h.start_effective_date) : null;
      const endDate = h.end_effective_date ? new Date(h.end_effective_date) : null;

      if (!startDate) return false;

      if (endDate && startDate > endDate) {
        return false;
      }

      const startDateOnly = new Date(startDate);
      startDateOnly.setHours(0, 0, 0, 0);

      const actualStartDate = startDateOnly;

      if (endDate) {
        const endDayEnd = new Date(endDate);
        endDayEnd.setHours(23, 59, 59, 999);
        return targetDateOnly >= actualStartDate && targetDateOnly <= endDayEnd;
      }

      return targetDateOnly >= actualStartDate;
    });

    // Cùng ngày: ưu tiên record đang kết thúc (end = hôm nay) rồi record mới bắt đầu (start = hôm nay)
    matchingRecords.sort((a, b) => {
      const aEnd = a.end_effective_date ? new Date(a.end_effective_date) : null;
      const bEnd = b.end_effective_date ? new Date(b.end_effective_date) : null;
      const aStart = a.start_effective_date ? new Date(a.start_effective_date) : null;
      const bStart = b.start_effective_date ? new Date(b.start_effective_date) : null;

      if (aEnd) {
        const aEndOnly = new Date(aEnd);
        aEndOnly.setHours(0, 0, 0, 0);
        const aEndsToday = aEndOnly.getTime() === targetDateOnly.getTime();

        if (bEnd) {
          const bEndOnly = new Date(bEnd);
          bEndOnly.setHours(0, 0, 0, 0);
          const bEndsToday = bEndOnly.getTime() === targetDateOnly.getTime();

          if (aEndsToday !== bEndsToday) {
            return aEndsToday ? -1 : 1;
          }
        } else {
          if (aEndsToday) return -1;
        }
      }

      if (bEnd) {
        const bEndOnly = new Date(bEnd);
        bEndOnly.setHours(0, 0, 0, 0);
        const bEndsToday = bEndOnly.getTime() === targetDateOnly.getTime();
        if (bEndsToday) return 1;
      }
      
      // Nếu không có end, ưu tiên record có start = targetDate
      if (aStart && bStart) {
        const aStartOnly = new Date(aStart);
        aStartOnly.setHours(0, 0, 0, 0);
        const bStartOnly = new Date(bStart);
        bStartOnly.setHours(0, 0, 0, 0);
        const aStartsToday = aStartOnly.getTime() === targetDateOnly.getTime();
        const bStartsToday = bStartOnly.getTime() === targetDateOnly.getTime();
        
        if (aStartsToday !== bStartsToday) {
          return aStartsToday ? -1 : 1;
        }
      }
      
      return 0;
    });
    
    const matchingHistory = matchingRecords[0];
    
    if (matchingHistory) {
      // Ưu tiên customer_price, không có thì dùng price
      return matchingHistory.customer_price !== null && matchingHistory.customer_price !== undefined
        ? matchingHistory.customer_price
        : (matchingHistory.price || defaultDevicePrice);
    }
    
    // Nếu không tìm thấy history phù hợp, tìm history gần nhất
    // Ưu tiên history sau ngày này, nếu không có thì lấy history trước
    // Loại bỏ record có start > end (chỉ áp dụng 1 ngày) khỏi danh sách tìm kiếm
    const futureHistory = history
      .filter(h => {
        const startDate = h.start_effective_date ? new Date(h.start_effective_date) : null;
        const endDate = h.end_effective_date ? new Date(h.end_effective_date) : null;
        // Loại bỏ record có start > end
        if (endDate && startDate && startDate > endDate) {
        return false;
        }
        return startDate && startDate > targetDate;
      })
      .sort((a, b) => {
        const dateA = new Date(a.start_effective_date);
        const dateB = new Date(b.start_effective_date);
        return dateA - dateB;
      });
    
    if (futureHistory.length > 0) {
      const nearestFuture = futureHistory[0];
      return nearestFuture.customer_price !== null && nearestFuture.customer_price !== undefined
        ? nearestFuture.customer_price
        : (nearestFuture.price || defaultDevicePrice);
    }
    
    // Nếu không có history sau, tìm history trước
    // Loại bỏ record có start > end (chỉ áp dụng 1 ngày) khỏi danh sách tìm kiếm
    const pastHistory = history
      .filter(h => {
        const startDate = h.start_effective_date ? new Date(h.start_effective_date) : null;
        const endDate = h.end_effective_date ? new Date(h.end_effective_date) : null;
        // Loại bỏ record có start > end
        if (endDate && startDate && startDate > endDate) {
          return false;
        }
        return endDate && endDate < targetDate;
      })
      .sort((a, b) => {
        const dateA = new Date(a.end_effective_date);
        const dateB = new Date(b.end_effective_date);
        return dateB - dateA;
      });
    
    if (pastHistory.length > 0) {
      const nearestPast = pastHistory[0];
      return nearestPast.customer_price !== null && nearestPast.customer_price !== undefined
        ? nearestPast.customer_price
        : (nearestPast.price || defaultDevicePrice);
    }
    
    // Nếu không có history nào, dùng giá mặc định từ device
    return defaultDevicePrice;
  };
  
  // Theo ngày: line trong [start,end]; ngày biên (cũ date_end = mới date_start = hôm nay) cộng 2 giá, không thì một line (ưu tiên valid).
  let totalDaysCounted = 0;
  for (let day = roomStartDay; day <= roomEndDay; day++) {
    const currentDate = new Date(year, month - 1, day);
    const cur = new Date(currentDate);
    cur.setHours(0, 0, 0, 0);

    const active = devicesWithDates.filter((d) => {
      const s = new Date(d.start);
      s.setHours(0, 0, 0, 0);
      const e = new Date(d.end);
      e.setHours(23, 59, 59, 999);
      return cur >= s && cur <= e;
    });

    let priceForDay = null;

    if (active.length) {
      const oldLine = active.find((d) => {
        if (d.device.is_valid || !d.device.date_end) return false;
        const od = clampDay31To30(new Date(d.device.date_end));
        od.setHours(0, 0, 0, 0);
        return od.getTime() === cur.getTime();
      });
      const newLine = active.find((d) => {
        if (!d.device.is_valid) return false;
        const ns = clampDay31To30(new Date(d.device.date_start));
        ns.setHours(0, 0, 0, 0);
        return ns.getTime() === cur.getTime();
      });
      if (oldLine && newLine) {
        priceForDay =
          getPriceForDate(oldLine, currentDate) + getPriceForDate(newLine, currentDate);
      } else {
        const one = active.find((d) => d.device.is_valid) || active[0];
        priceForDay = getPriceForDate(one, currentDate);
      }
    }

    if (priceForDay !== null) {
      totalInternetPriceDays += priceForDay;
      totalDaysCounted++;
    }
  }
  
  
  // Giá TB internet: tổng theo ngày (totalInternetPriceDays) / 30 — cùng nguồn với vòng lặp getPriceForDate ở trên
  let averageInternetPrice = 0;
  if (totalInternetPriceDays > 0) {
    averageInternetPrice = Math.round(totalInternetPriceDays / 30);
  }
  
  // Set bill cho tất cả internet devices
  internetDevices.forEach(device => {
    if (device.date_count > 0) {
      device.bill = averageInternetPrice;
    }
  });
  
  
  return averageInternetPrice;
};

const handleDevice = (arr, price = 0, chosen_month, date_end, internetPriceHistory = {}, roomDateStart = null, roomDateEnd = null, allInternetUsers = null) => {
  const data = [];
  let total_bill = 0;
  
  const internetDevices = arr.filter(d => d.type === "INTERNET");
  const otherDevices = arr.filter(d => d.type !== "INTERNET");
  
  if (internetDevices.length > 0) {
    const internetBill = calculateInternetBill(internetDevices, chosen_month, date_end, internetPriceHistory, roomDateStart, roomDateEnd);
    total_bill += internetBill;
    data.push(...internetDevices.filter(d => d.date_count > 0));
  }
  
  otherDevices.forEach((device) => {
    device.date_count = handleDateCount({
      date_start: device.date_start,
      chosen_month,
      date_end: device.is_valid ? date_end : device.date_end,
      is_room_date_count: device.type === "AC",
    });

    let devicePrice = price;
    if (device.type === "AC") {
      devicePrice = device.price || price;
    }

    if (device.date_count) {
      data.push(device);
      device.bill = Math.round((devicePrice / 30) * device.date_count);
      total_bill += device.bill;
    }
  });
  return { data, total_bill };
};

const findDateRangeCollapse = (date_range_1, date_range_2) => {
  if (
    date_range_1.end < date_range_2.start ||
    date_range_2.end < date_range_1.start
  )
    return 0;
  const end =
    date_range_1.end < date_range_2.end ? date_range_1.end : date_range_2.end;
  const start =
    date_range_1.start > date_range_2.start
      ? date_range_1.start
      : date_range_2.start;
  return { end, start };
};

const handleDateCountV2 = (
  date_range_1,
  date_range_2,
  chosen_month,
  date_end
) => {
  const end_range = new Date(date_end);
  const last_date_of_chosen_month = new Date(
    getLastDateOfChosenMonth(chosen_month)
  );
  const month = {
    start: new Date(chosen_month + "-01"),
    end: end_range,
  };
  date_range_1.end = date_range_1.end ? date_range_1.end : month.end;
  date_range_2.end = date_range_2.end ? date_range_2.end : month.end;

  const date_range_1_chosen_month = findDateRangeCollapse(date_range_1, month);
  const date_range_2_chosen_month = findDateRangeCollapse(date_range_2, month);

  // @C Trân CG bất kể tháng có 28, 29, 31 ngày, bắt đầu dùng từ ngày 28 thì vẫn tính tổng số ngày dùng là 30 - 28 + 1 = 3 ngày đúng ko chị?
  // @Trung Sơn đúng rồi. Ngày 28, 29, 30.

  if (date_range_1_chosen_month && date_range_2_chosen_month) {
    const final_range = findDateRangeCollapse(
      date_range_1_chosen_month,
      date_range_2_chosen_month
    );
    if (final_range) {
      // Bắt đầu và kết thúc cùng 1 ngày
      if (final_range.start.toDateString() === final_range.end.toDateString())
        return 1;

      // Dùng full tháng
      if (
        moment(final_range.start).diff(moment(month.start), "days") == 0 &&
        moment(final_range.end).diff(
          moment(last_date_of_chosen_month),
          "days"
        ) == 0
      )
        return 30;

      // Nếu tới cuối tháng thì tính theo công thức 30 - ngày bắt đầu + 1
      if (
        moment(final_range.end).diff(
          moment(last_date_of_chosen_month),
          "days"
        ) == 0
      ) {
        return 30 - final_range.start.getDate() + 1;
      }

      return final_range.end.getDate() - final_range.start.getDate() + 1;
    }
  }
  return 0;
};

const handleWashingMachine = (
  washing_machines,
  price,
  customers,
  chosen_month,
  date_end
) => {
  const data = [];
  let total_bill = 0;
  washing_machines.forEach((wash) => {
    customers.forEach((cus) => {
      const date_range_1 = {
        start: wash.date_start
          ? new Date(wash.date_start.substr(0, 10))
          : new Date(),
        end: wash.date_end ? new Date(wash.date_end) : "",
      };
      const date_range_2 = {
        start: cus.date_in ? new Date(cus.date_in.substr(0, 10)) : new Date(),
        end: cus.date_out ? new Date(cus.date_out) : "",
      };
      let date_count = handleDateCountV2(
        date_range_1,
        date_range_2,
        chosen_month,
        date_end
      );
      date_count = date_count > 30 ? 30 : date_count;
      const bill = (price / 30) * date_count;
      total_bill += bill;
      data.push({
        ...cus,
        date_count,
        bill,
        price,
        washing_machine: wash,
      });
    });
  });
  total_bill = Math.round(total_bill);
  return { data, total_bill };
};
// const roundMoney = (price) => {
//     let
//     return round_to_precision
// };
const calculateWaterPrice = (diff, price) => {
  if (price > 10000) {
    return price * diff;
  } else {
    return diff > 8 ? 8 * 10000 + (diff - 8) * 15000 : diff * 10000;
  }
};

const calculateRoomBill = async (
  room,
  chosen_month,
  date_end,
  date_schedule_end,
  is_check_out,
  check_in_month_date_count = 0,
  allInternetUsers = null,
  allPriceHistory = null,
) => {
  // console.log(room.room_id);
  // Xử lý phòng
  const date_start =
    room.date_in > room.date_schedule_in ? room.date_schedule_in : room.date_in;

  
  room.date_count = handleDateCount({
    date_start,
    chosen_month,
    date_end: date_schedule_end ? date_schedule_end : date_end,
    is_room_date_count: true,
    date_schedule_end,
    is_check_out,
  });

  room.date_count = check_in_month_date_count + room.date_count;

  room.service_date_count = handleDateCount({
    date_start,
    chosen_month,
    date_end,
  });

  room.room_bill = Math.round((room.room_price / 30) * room.date_count);
  room.trash_bill = Math.round(
    (room.trash_price / 30) * room.service_date_count
  );
  // Xử lý diện
  room.electric = handelElectricWaterPrice(room.electric);
  if (room.electric_meter_change) {
    room.electric.total_bill = Math.round(
      (room.electric.end - room.electric_meter_change.new_meter_number + room.electric_meter_change.old_meter_number - room.electric.start) * room.electric_price
    );
  } else {
    room.electric.total_bill = Math.round(
      (room.electric.end - room.electric.start) * room.electric_price
    );
  }


  // Xử lý nước
  room.water = handelElectricWaterPrice(room.water);
  if (room.water_meter_change) {
    room.water.total_bill = calculateWaterPrice(
      room.water.end - room.water_meter_change.new_meter_number + room.water_meter_change.old_meter_number - room.water.start,
      room.water_price
    );
  } else {
    room.water.total_bill = calculateWaterPrice(
      room.water.end - room.water.start,
      room.water_price
    );
  }
  // Xử lý device
  // let device_data = handleDevicePrice(room.deviceInfo, room, chosen_month, date_end)
  // Xủ lý Internet
  const internetPriceHistory = await getInternetPriceHistoryForDevices(room.internet, allInternetUsers, allPriceHistory);
  
  // Lấy date_start từ bảng internet (field date_start), không phải từ device
  // Ưu tiên internet record có date_start trong tháng chosen_month, nếu không có thì dùng date_start từ room
  let roomDateStart = null;
  
  // Tìm internet record từ allInternetUsers
  if (allInternetUsers && room.internet && room.internet.length > 0) {
    const [year, month] = chosen_month.split('-').map(Number);
    const monthStart = new Date(year, month - 1, 1);
    monthStart.setHours(0, 0, 0, 0);
    const monthEnd = new Date(year, month - 1, 30, 23, 59, 59);
    
    // Tìm internet record valid có date_start trong tháng chosen_month
    // Lấy internet record từ device (dựa vào room_id, building, và is_valid)
    const firstValidDevice = room.internet.find(device => 
      device.type === "INTERNET" && device.is_valid && device.room_id && device.building
    );
    
    if (firstValidDevice) {
      const internetRecord = allInternetUsers.find(user => 
        user.room_id === firstValidDevice.room_id && 
        user.building === firstValidDevice.building && 
        user.is_valid
      );
      
      if (internetRecord && internetRecord.date_start) {
        const internetDateStart = new Date(internetRecord.date_start);
        internetDateStart.setHours(0, 0, 0, 0);
        
        // Check xem date_start của internet có trong tháng chosen_month không
        if (internetDateStart >= monthStart && internetDateStart <= monthEnd) {
          roomDateStart = internetDateStart;
        } else {
          // Nếu không trong tháng, vẫn dùng date_start từ internet (có thể trước tháng)
          roomDateStart = internetDateStart;
        }
        
      }
    }
  }
  
  // Fallback: Nếu không tìm thấy từ internet record, dùng date_start từ device (logic cũ)
  if (!roomDateStart && room.internet && room.internet.length > 0) {
    const [year, month] = chosen_month.split('-').map(Number);
    const monthStart = new Date(year, month - 1, 1);
    monthStart.setHours(0, 0, 0, 0);
    const monthEnd = new Date(year, month - 1, 30, 23, 59, 59);
    
    // Tìm device valid có date_start trong tháng chosen_month
    const validDevicesInMonth = room.internet.filter(device => {
      if (!device.is_valid) return false;
      const deviceStart = new Date(device.date_start);
      deviceStart.setHours(0, 0, 0, 0);
      return deviceStart >= monthStart && deviceStart <= monthEnd;
    });
    
    if (validDevicesInMonth.length > 0) {
      // Lấy device có date_start lớn nhất (mới nhất) nếu có nhiều
      validDevicesInMonth.sort((a, b) => new Date(b.date_start) - new Date(a.date_start));
      roomDateStart = new Date(validDevicesInMonth[0].date_start);
    }
  }
  
  // Nếu vẫn không tìm thấy, dùng date_start từ room
  if (!roomDateStart && date_start) {
    roomDateStart = new Date(date_start);
  }
  
  const roomDateEnd = date_schedule_end ? new Date(date_schedule_end) : (date_end ? new Date(date_end) : null);
  
  room.internet = handleDevice(room.internet, 0, chosen_month, date_end, internetPriceHistory, roomDateStart, roomDateEnd, allInternetUsers);
  // room.washing_machine = handleDevice(
  // 	room.washing_machine,
  // 	room.washing_machine_price * room.customer_count,
  // 	chosen_month,
  // 	date_end
  // );
  room.washing_machine = handleWashingMachine(
    room.washing_machine,
    room.washing_machine_price,
    room.customers,
    chosen_month,
    date_end
  );
  room.air_conditioner = handleDevice(
    room.air_conditioner,
    room.air_conditioner_price,
    chosen_month,
    date_end
  );
  room.bike = handleDevice(room.bike, room.bike_price, chosen_month, date_end);
  room.motorbike = handleDevice(
    room.motorbike,
    room.motorbike_price,
    chosen_month,
    date_end
  );
  if (room.is_included_air_conditioner) room.air_conditioner.total_bill = 0;
  room.total_bill =
    Math.round(
      (room.room_bill +
        room.electric.total_bill +
        room.water.total_bill +
        room.bike.total_bill +
        room.motorbike.total_bill +
        room.washing_machine.total_bill +
        room.air_conditioner.total_bill +
        room.internet.total_bill +
        room.trash_bill) /
      1000
    ) * 1000;
  return room;
};

function roundToNearestThousand(amount) {
  const remainder = amount % 1000;

  if (remainder >= 500) {
    return amount + (1000 - remainder); // Làm tròn lên
  } else if (remainder <= -500) {
    return amount - (1000 + remainder); // Làm tròn lên cho số âm
  } else {
    return amount - remainder; // Làm tròn xuống
  }
}

const calculateRoomBillWithDebts = (
  // để tính hóa đơn cộng dồn
  bill,
) => {
  let room_bill_with_debts = { total_bill: 0 };
  let dateIn;
  if (bill.is_include_checkin_month_debt) {
    if (bill.is_checkin_and_checkout_in_the_same_month) {
      dateIn = new Date(bill.date_in).toISOString();
    } else if (bill.last_month_payment && bill.last_month_payment.date_in) {
      dateIn = new Date(bill.last_month_payment.date_in).toISOString();
    }
  }
  if (
    bill.debt_details_full_tmp === undefined ||
    !bill.debt_details_full_tmp.length
  ) {
    const electricTermStartDate = new Date(bill.date_out);
    electricTermStartDate.setMonth(electricTermStartDate.getMonth());
    electricTermStartDate.setDate(1);

    let electricConsume = bill.electric.end - bill.electric.start;
    if (bill.electric_meter_change) {
      electricConsume = bill.electric.end - bill.electric_meter_change.new_meter_number + bill.electric_meter_change.old_meter_number - bill.electric.start;
    }
    room_bill_with_debts.electric = {
      startDate: bill.is_include_checkin_month_debt ? dateIn : electricTermStartDate.toISOString(),
      start: bill.electric.start,
      end: bill.electric.end,
      consume: electricConsume,
      total_bill: bill.electric.total_bill,
    };

    const waterTermStartDate = new Date(bill.date_out);
    waterTermStartDate.setDate(1); // Tránh lỗi tháng không có ngày 31 nhảy sang tháng sau
    waterTermStartDate.setMonth(waterTermStartDate.getMonth() - 1);
    waterTermStartDate.setDate(12);

    let waterConsume = bill.water.end - bill.water.start;
    if (bill.water_meter_change) {
      waterConsume = bill.water.end - bill.water_meter_change.new_meter_number + bill.water_meter_change.old_meter_number - bill.water.start;
    }
    room_bill_with_debts.water = {
      startDate: bill.is_include_checkin_month_debt ? dateIn : waterTermStartDate.toISOString(),
      start: bill.water.start,
      end: bill.water.end,
      consume: waterConsume,
      total_bill: bill.water.total_bill,
    };
    const serviceDate = new Date(bill.date_out);
    serviceDate.setDate(1);
    const serviceTermStartDate = serviceDate.toISOString();

    room_bill_with_debts.trash = {
      startDate: serviceTermStartDate,
      total_bill: bill.trash_bill,
    };

    room_bill_with_debts.vehicle = {
      startDate: serviceTermStartDate,
      total_bill: bill.motorbike.total_bill + bill.bike.total_bill,
    };

    room_bill_with_debts.washingMachine = {
      startDate: serviceTermStartDate,
      total_bill: bill.washing_machine ? bill.washing_machine.total_bill : 0,
    };

    room_bill_with_debts.airConditioner = {
      startDate: serviceTermStartDate,
      total_bill: bill.air_conditioner ? bill.air_conditioner.total_bill : 0,
    };

    room_bill_with_debts.internet = {
      startDate: serviceTermStartDate,
      total_bill: bill.internet ? bill.internet.total_bill : 0,
    };
  } else {
    const oldestDebtMonth = bill.debt_details_full_tmp[bill.debt_details_full_tmp.length - 1];
    const [year, month] = oldestDebtMonth.month.split("-").map(Number);

    const electricTermStartDate = new Date(year, month - 1, 1);

    let electricConsume = bill.electric.end - oldestDebtMonth.electric.start;
    if (bill.electric_meter_change) {
      electricConsume = bill.electric.end - bill.electric_meter_change.new_meter_number + bill.electric_meter_change.old_meter_number - oldestDebtMonth.electric.start;
    } else if (oldestDebtMonth.electric_meter_change) {
      electricConsume = bill.electric.end - oldestDebtMonth.electric_meter_change.new_meter_number + oldestDebtMonth.electric_meter_change.old_meter_number - oldestDebtMonth.electric.start;
    }

    room_bill_with_debts.electric = {
      startDate: bill.is_include_checkin_month_debt ? dateIn : electricTermStartDate.toISOString(),
      start: oldestDebtMonth.electric.start,
      end: bill.electric.end,
      consume: electricConsume,
      total_bill:
        bill.electric.total_bill +
        bill.debt_details_full_tmp.reduce(
          (acc, cur) => acc + cur.electric.total_bill,
          0
        ),
    };

    const waterTermStartDate = new Date(year, month - 2, 12);

    let waterConsume = bill.water.end - oldestDebtMonth.water.start;
    if (bill.water_meter_change) {
      waterConsume = bill.water.end - bill.water_meter_change.new_meter_number + bill.water_meter_change.old_meter_number - oldestDebtMonth.water.start;
    } else if (oldestDebtMonth.water_meter_change) {
      waterConsume = bill.water.end - oldestDebtMonth.water_meter_change.new_meter_number + oldestDebtMonth.water_meter_change.old_meter_number - oldestDebtMonth.water.start;
    }

    room_bill_with_debts.water = {
      startDate: bill.is_include_checkin_month_debt ? dateIn : waterTermStartDate.toISOString(),
      start: oldestDebtMonth.water.start,
      end: bill.water.end,
      consume: waterConsume,
      total_bill:
        bill.water.total_bill +
        bill.debt_details_full_tmp.reduce(
          (acc, cur) => acc + cur.water.total_bill,
          0
        ),
    };

    const serviceTermStartDate = new Date(year, month - 1, 1).toISOString();

    room_bill_with_debts.trash = {
      startDate: serviceTermStartDate,
      total_bill:
        bill.trash_bill +
        bill.debt_details_full_tmp.reduce(
          (acc, cur) => acc + cur.trash_bill,
          0
        ),
    };

    room_bill_with_debts.vehicle = {
      startDate: serviceTermStartDate,
      total_bill:
        bill.motorbike.total_bill +
        bill.bike.total_bill +
        bill.debt_details_full_tmp.reduce(
          (acc, cur) => acc + cur.motorbike.total_bill + cur.bike.total_bill,
          0
        ),
    };

    room_bill_with_debts.washingMachine = {
      startDate: serviceTermStartDate,
      total_bill:
        (bill.washing_machine ? bill.washing_machine.total_bill : 0) +
        bill.debt_details_full_tmp.reduce(
          (acc, cur) =>
            acc + (cur.washing_machine ? cur.washing_machine.total_bill : 0),
          0
        ),
    };

    room_bill_with_debts.airConditioner = {
      startDate: serviceTermStartDate,
      total_bill:
        (bill.air_conditioner ? bill.air_conditioner.total_bill : 0) +
        bill.debt_details_full_tmp.reduce(
          (acc, cur) =>
            acc + (cur.air_conditioner ? cur.air_conditioner.total_bill : 0),
          0
        ),
    };

    room_bill_with_debts.internet = {
      startDate: serviceTermStartDate,
      total_bill:
        (bill.internet ? bill.internet.total_bill : 0) +
        bill.debt_details_full_tmp.reduce(
          (acc, cur) => acc + (cur.internet ? cur.internet.total_bill : 0),
          0
        ),
    };
  }

  room_bill_with_debts.total_bill =
    bill.room_bill +
    room_bill_with_debts.electric.total_bill +
    room_bill_with_debts.water.total_bill +
    room_bill_with_debts.trash.total_bill +
    room_bill_with_debts.vehicle.total_bill +
    room_bill_with_debts.washingMachine.total_bill +
    room_bill_with_debts.airConditioner.total_bill +
    room_bill_with_debts.internet.total_bill;

  return room_bill_with_debts;
};

export {
  calculateRoomBill,
  getLastDateOfChosenMonth,
  calculateRoomBillWithDebts,
  roundToNearestThousand,
  handleDateCount,
};
